import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import ContactActivityRowCard from "./ContactActivityCard";
import { onContactActivity } from "common/signalR";

interface Props {
  contactId: number
  config: server.dto.ActivityPanelConfig
}

const ContactActivityPanel = (props: Props) => {
  const { contactId, config } = props;

  return <ActivityPanel<server.dto.ContactActivity>
    activityKey="contact"
    itemId={contactId}
    config={config}
    fetchActivities={(page, perPage) => window.CoreApi.Contact.ListActivity({ page, perPage, itemId: contactId })}
    renderActivity={(activity) => <ContactActivityRowCard key={activity.activityId} activity={activity} />}
    onActivityRegisterFn={onContactActivity}
    onActivity={() => ({ refreshActivities: true })}
  />;
};

export default ContactActivityPanel;
